import { ErrorMessageEn, ErrorMessageEs } from '$constants/alerts';
import { errorHandler } from '$store/utils';
import { userLanguage, ValidLanguages } from '$translations/index';
import {
  SendVideoCommentInput,
  SendVideoCommentOutput,
  VideoFeedbackBuilder,
} from '../video-feedback.types';

export const sendVideoComment = (builder: VideoFeedbackBuilder) =>
  builder.mutation<SendVideoCommentOutput, SendVideoCommentInput>({
    query: ({ videoId, videoType, videoComment }) => ({
      url: `/feedbacks`,
      method: 'POST',
      body: { EntityName: videoType, EntityId: videoId, Comment: videoComment },
    }),
    transformErrorResponse: (error) => {
      errorHandler(
        '[SendVideoCommentAction]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.FeedbackError
          : ErrorMessageEn.FeedbackError,
        error,
        true
      );
    },
    invalidatesTags: (baseQuery, meta, { videoId }) => [
      { type: 'videoFeedback', id: videoId },
    ],
  });
